import React from 'react';
import aideTrouve from '../img/oui-css.png';
import alert from '../img/alert.png';
import logo from "../img/logo-bleu.webp";
import Telephone from './telephone.js';


export default function PositiveResult (props) {
	const droit = props.droit;

	return <><div className="inner-container">
		<div className="result-image">
			<img src={aideTrouve}
			  alt="Aide trouvé"
			  className='result-img'
			/>
		</div>
		<div className="result-info">
			<h4>Bonne nouvelle !</h4>
			<div>
              <p>
                Selon les informations que vous avez saisies, vous pouvez prétendre
                <br />
                à la
                <span className="font-bold"> {droit.label}</span>
              </p>

			  { ( typeof droit.value  === "boolean" ) ?
				<div className="mt-2 mb-3" >
					<span className="font-size-14rem font-bold valeur-result"> gratuitement </span>
				</div>

				:<div className="mt-2 mb-3" ng-show="droit.isbool === false">
					<span>pour</span>
					<span className="font-size-14rem font-bold"> {droit.value} {droit.unit} € / Mois</span>
					<span>{droit.periodLabel}</span>
				</div>
			  }
			  <div className="warning d-flex">
				<div>
				<img src={alert} alt="Attention" />
				</div>
				<div className="warning-text">
					<span>Attention, la simulation vous informe mais n'a aucune valeur officielle.</span>
				</div>
				
			  </div>
			  <a href={droit.link} target="_blank" className="b-link font-bold">
				<u>Comment l'obtenir ?</u>
			  </a>
			  <Telephone/>
			  <div className="restart-btn-container">
				<button className='button active restart' onClick={props.restart}>Recommencer</button>
			  </div>
			  <p className="result-info-text">Vous avez certainement droit à d'autres aides ! Effectuez gratuitement une simulation globale sur plus de 300 dispositifs pour le savoir.</p>
				<div className="simulation-btn-container">
				<a className='b-link' 
					href="https://www.aide-sociale.fr/questionnaire-steps/"
					target="_blank">
					<button className="button">Simulez vos droits</button>
				</a>
				</div>
            </div>
		</div>

	</div>
<div className="site-address pt-3 pt-sm-0">
      <div className="col">
        <img src={logo} alt="logo aide-sociale.fr"/>
      </div>
    </div>
	</>
}